import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';

@Component({
    templateUrl: './client-portal-prescription-report.component.html',
    imports: [ReportsComponent]
})
export class ClientPortalPrescriptionReportComponent {
  reportsUrl = `${environment.captureApi.url}/client_prescription_reports`;
  reportsCountUrl = `${environment.captureApi.url}/client_prescription_reports/count`;
}
